import { render, staticRenderFns } from "./evalGoalsTab.vue?vue&type=template&id=6def741c&scoped=true"
import script from "./evalGoalsTab.vue?vue&type=script&lang=ts"
export * from "./evalGoalsTab.vue?vue&type=script&lang=ts"
import style0 from "./evalGoalsTab.vue?vue&type=style&index=0&id=6def741c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def741c",
  null
  
)

export default component.exports